export function truncateWithEllipses(
  text: string,
  max: number,
  ending = "…"
): string {
  return text.length > max
    ? text.substr(0, max - ending.length) + ending
    : text;
}
